"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var Paper_1 = __importDefault(require("../Paper"));

var util_1 = require("../styles/util");

var styles = function styles(props) {
  return createStyles_1.createStyles({
    root: {}
  });
};

var Panel = React.forwardRef(function (props, ref) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      enableCollapse = props.enableCollapse,
      expanded = props.expanded,
      padding = props.padding,
      margin = props.margin,
      onToggle = props.onToggle,
      paperProps = __rest(props, ["classes", "className", "children", "enableCollapse", "expanded", "padding", "margin", "onToggle"]);

  var expandedState = enableCollapse && expanded !== undefined ? expanded : false;

  var _React$useState = React.useState(expandedState),
      panelExpanded = _React$useState[0],
      togglePanel = _React$useState[1];

  React.useEffect(function () {
    if (expanded !== undefined && expanded !== panelExpanded) {
      togglePanel(expanded);
    }
  }, [expanded]);

  var handlePanelToggle = function handlePanelToggle() {
    togglePanel(!panelExpanded);

    if (onToggle) {
      onToggle(!panelExpanded);
    }
  };

  var rootClasses = clsx_1.default(classes.root, util_1.createPaddingClassNames({
    padding: padding
  }), util_1.createMarginClassNames({
    margin: margin
  }), className);
  var childrenArray = React.Children.toArray(children);
  var panelBody = childrenArray.map(function (step) {
    var state = {
      enableCollapse: enableCollapse,
      panelExpanded: panelExpanded || false,
      handlePanelToggle: handlePanelToggle,
      square: props.square
    };
    return [React.cloneElement(step, Object.assign(Object.assign({}, state), step.props))];
  });
  return React.createElement(Paper_1.default, Object.assign({
    className: rootClasses
  }, paperProps, {
    ref: ref
  }), panelBody);
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiPanel'
})(Panel);